"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var components_1 = require("components");
var componentStyle = {
    base: {
        display: 'flex',
        margin: '50px 0 70px',
        justifyContent: 'space-around',
    },
    container: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    name: {
        fontSize: 14,
        marginTop: 10,
    },
};
exports.Icons = function () { return (React.createElement("div", { style: componentStyle.base },
    React.createElement("div", { style: componentStyle.container },
        React.createElement(components_1.Icon, { name: "expandLess" }),
        React.createElement("span", { style: componentStyle.name }, "expandLess")),
    React.createElement("div", { style: componentStyle.container },
        React.createElement(components_1.Icon, { name: "expandMore" }),
        React.createElement("span", { style: componentStyle.name }, "expandMore")),
    React.createElement("div", { style: componentStyle.container },
        React.createElement(components_1.Icon, { name: "file" }),
        React.createElement("span", { style: componentStyle.name }, "file")),
    React.createElement("div", { style: componentStyle.container },
        React.createElement(components_1.Icon, { name: "list" }),
        React.createElement("span", { style: componentStyle.name }, "list")),
    React.createElement("div", { style: componentStyle.container },
        React.createElement(components_1.Icon, { name: "menu" }),
        React.createElement("span", { style: componentStyle.name }, "menu")),
    React.createElement("div", { style: componentStyle.container },
        React.createElement(components_1.Icon, { name: "plus" }),
        React.createElement("span", { style: componentStyle.name }, "plus")),
    React.createElement("div", { style: componentStyle.container },
        React.createElement(components_1.Icon, { name: "search" }),
        React.createElement("span", { style: componentStyle.name }, "search")))); };
exports.Icons.displayName = 'Icons';



//////////////////
// WEBPACK FOOTER
// ./src/docs/pages/ComponentIconPage/Icons.tsx
// module id = 687
// module chunks = 0